import gql from 'graphql-tag';

export const businessTypes = gql`
query getBusinessTypes($type: String!){
  directory_business_types(where: {type: {_eq: $type}}){
      id
      type
      name
      directory_categories{
        id
        name
      }
    }
  }
`;


export const addNewBusinessType = gql`

mutation demo($favObj: directory_categories_insert_input!) {
  insert_directory_categories_one(object: $favObj) {
    id
  }
}

`;




export const addProf = gql`mutation update_dental_professionals_by_pk($id: uuid! ,$profObj: dental_professionals_set_input!){
  update_dental_professionals_by_pk(pk_columns:{id: $id}, _set: $profObj){
    id
  }
}`;


export const addSupplier = gql`

mutation addSupplier($id: uuid!, $supplierObj: dental_suppliers_set_input!) {
  update_dental_suppliers(where:{id:{_eq: $id}},_set: $supplierObj) {
   affected_rows
    
  }
}

`;

export const addPractice = gql`

mutation addPractice($id: uuid!, $practiceObj: dental_practices_set_input!) {
  update_dental_practices(where:{id:{_eq: $id}},_set: $practiceObj) {
   affected_rows
    
  }
}

`;


// export const addProfContact = gql`

// mutation addProf($id: uuid!, $contactProfObj: dental_professionals_set_input!) {
//   update_dental_professionals(where:{id:{_eq: $id}},_set: $contactProfObj) {
//    affected_rows
    
//   }
// }

// `;


export const addProfContact = gql`

mutation addProf($id: uuid!, $contactProfObj: dental_professionals_set_input!) {
  update_dental_professionals(where:{id:{_eq: $id}},_set: $contactProfObj) {
   affected_rows
    
  }
}

`;

export const addSupplierContact = gql`

mutation addSupplierContact($id: uuid!, $contactSupplierObj: dental_suppliers_set_input!) {
  update_dental_suppliers(where:{id:{_eq: $id}},_set: $contactSupplierObj) {
   affected_rows
    
  }
}

`;

export const addPracticeContact = gql`

mutation addPracticeContact($id: uuid!, $contactPracticeObj: dental_practices_set_input!) {
  update_dental_practices(where:{id:{_eq: $id}},_set: $contactPracticeObj) {
   affected_rows
    
  }
}

`;



export const addProfProfDetails = gql`

mutation addProf($id: uuid!, $profProfDetails: dental_professionals_set_input!) {
  update_dental_professionals(where:{id:{_eq: $id}},_set: $profProfDetails) {
   affected_rows
    
  }
}

`;

export const addSupplierProfDetails = gql`

mutation addSupplierContact($id: uuid!, $profSupplierDetails: dental_suppliers_set_input!) {
  update_dental_suppliers(where:{id:{_eq: $id}},_set: $profSupplierDetails) {
   affected_rows
    
  }
}

`;

export const addPracticeProfDetails = gql`

mutation addPracticeContact($id: uuid!, $profPracticeDetails: dental_practices_set_input!) {
  update_dental_practices(where:{id:{_eq: $id}},_set: $profPracticeDetails) {
   affected_rows
    
  }
}

`;



export const addProfOtherDetails = gql`

mutation addProfOtherDetails($id: uuid!, $profBankDetails: dental_professionals_set_input!) {
  update_dental_professionals(where:{id:{_eq: $id}},_set: $profBankDetails) {
   affected_rows
    
  }
}

`;

export const addSupplierOtherDetails = gql`

mutation addSupplierOtherDetails($id: uuid!, $supplierBankDetails: dental_suppliers_set_input!) {
  update_dental_suppliers(where:{id:{_eq: $id}},_set: $supplierBankDetails) {
   affected_rows
    
  }
}

`;

export const addPracticeOtherDetails = gql`

mutation addPracticeOtherDetails($id: uuid!, $practiceBankDetails: dental_practices_set_input!) {
  update_dental_practices(where:{id:{_eq: $id}},_set: $practiceBankDetails) {
   affected_rows
    
  }
}

`;





export const supplierAddresses = gql`

mutation supplierAddresses($detaultAddress: dental_supplier_addresses_insert_input!) {
  insert_dental_supplier_addresses_one(object: $detaultAddress) {
    id
  }
}

`;

export const practiceAddresses = gql`

mutation practiceAddresses($detaultAddress: dental_practice_addresses_insert_input!) {
  insert_dental_practice_addresses_one(object: $detaultAddress) {
    id
  }
}

`;

export const professinalAddresses = gql`

mutation professinalAddresses($detaultAddress: dental_professional_addresses_insert_input!) {
  insert_dental_professional_addresses_one(object: $detaultAddress) {
    id
  }
}

`;